import React from 'react'

import { Box } from 'components/layout/Box/Box'
import { Chip } from 'components/shared/Chip/Chip'
import { Table } from 'components/shared/Table/Table'

import type { TableCellProps } from '../../../types'

import styles from './ChipCell.module.scss'

type ChipCellProps = Pick<TableCellProps, 'maxWidth' | 'hasIncreasedHeight'> &
  Pick<React.ComponentProps<typeof Chip>, 'color' | 'label'>

export const ChipCell = ({
  color,
  label,
  maxWidth,
  hasIncreasedHeight,
}: ChipCellProps) => (
  <Table.Cell type="body" {...{ maxWidth, hasIncreasedHeight }}>
    <Box
      align="center"
      className={styles.content}
      justify="center"
      tagName="span"
    >
      <Chip size="medium" variant="filled" {...{ color, label }} />
    </Box>
  </Table.Cell>
)
